<template>
  <div class="info-window">
    <div v-for="(group, index) in groups" :key="index" :class="groupClass">
      <div v-if="singleProvider" class="provider">
        <div class="provider-label">
          <h2>
            <a :href="mapLink(group.result.url)">{{ group.result.label }}</a>
          </h2>
        </div>
      </div>
      <address>
        <strong class="address-title">{{ mapText("address") }}<br /></strong>
        <template v-if="group.locations.length"
          ><strong v-for="location in group.locations" :key="location.resultGUID" class="address-name" translate="no"
            ><a v-if="location.url" :href="mapLink(location.url)">{{ location.label }}</a
            ><template v-else>{{ location.label }}</template
            ><br /></strong
        ></template>
        <strong v-else-if="group.result.address_name" class="address-name" translate="no"
          >{{ group.result.address_name }}<br
        /></strong>
        <span translate="no">{{ group.result.street_address }}</span
        ><br />
        <span translate="no">{{ group.result.city }}, {{ group.result.state }} {{ group.result.zip_code }}</span
        ><br />
        <span translate="no">{{ group.result.phone_number }}</span>
      </address>
      <div v-if="group.result.directions_url" class="links">
        <a
          class="info-directions link"
          :href="mapLink(group.result.directions_url)"
          target="_blank"
          rel="noopener noreferrer"
          ><i class="icon-directions-outlined icon"></i> {{ mapText("directions") }}</a
        >
      </div>
      <div v-for="provider in group.providers" :key="providerKey(provider)" class="provider">
        <img class="provider-image" :src="provider.image_url" alt="" />
        <div :class="providerLabelClass">
          <h2>
            <a :href="mapLink(provider.url)">{{ provider.label }}</a>
          </h2>
          <div v-if="showsSpecialties(provider)" class="specialties">
            {{ provider.skills.map(skillName).join(", ") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { mapLink } from "#ce/apps/SpFinderMap/lib/map-link";
import { mapText } from "#ce/apps/SpFinderMap/lib/map-text";
import { useFinderMapInfoWindow } from "#ce/apps/SpFinderMap/composables/useFinderMapInfoWindow";
const props = defineProps({ content: { type: Object, required: true } });
const { groups, singleProvider, groupClass, providerLabelClass, showsSpecialties, providerKey, skillName } =
  useFinderMapInfoWindow(props);
</script>
